import type * as fromRouter from '@ngrx/router-store';
import { createFeatureSelector, select } from '@ngrx/store';
import { ROUTER_FEATURE_KEY } from './router.reducer';
import type { NmoBaseRouterStoreState } from './';
import { pipe } from 'rxjs';
import { filter } from 'rxjs/operators';

export const getRouterState =
  createFeatureSelector<fromRouter.RouterReducerState<NmoBaseRouterStoreState>>(ROUTER_FEATURE_KEY);

export const getRouterStateEvents = pipe(
  select(getRouterState),
  filter((val) => !!val)
);
